// @flow
import React, { type Node } from 'react';
import styles from './FootNotes.scss';


type Props = {
  notes: Object,
  keys: Array<string>,
  injectSMSCost?: Node,
}

const FootNote = ({ notes, keys, injectSMSCost }: Props) => (
  (notes && keys && !!keys.length
    && <div className={styles.root}>
      {keys.map((key, i) =>
        (notes[key]
          ? <div key={key}>
            <span className={styles.num}>{i + 1}</span>
            <span>{` — ${notes[key].text}`}</span>
            {(key === 'sms' || key === 'smspack') ? injectSMSCost : null}
          </div>
          : null
        ))}
    </div>)
  || null
);

export default FootNote;
